class EHBOFields {
	constructor() {

		this.initEventListeners()
	}

	initEventListeners() {
		let $ehboSwitch = $('[data-ehbo-account]');
		$ehboSwitch.on('click', this.ehboSwitchListener.bind(this));
		$ehboSwitch.each(function(it,el) {
			this.toggleEHBOFields($(el));
		}.bind(this));
	}

	ehboSwitchListener(e) {
		this.toggleEHBOFields($(e.currentTarget));
	}

	toggleEHBOFields($input) {
		$('[data-ehbo-account-display]').each((it, el) => {
			if ($input.is(':checked')) {
				return $(el).closest('.form-group').removeClass('d-none');
			}

			$(el).closest('.form-group').addClass('d-none');
		});
	}
}

export default new EHBOFields;
